export default __webpack_public_path__ + "static/media/cp_geo_my.645d2fbf.svg";